var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card, Tooltip, TooltipTrigger } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { expression, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { getCountryCallingCode, isSupportedCountry, parsePhoneNumberFromString } from 'libphonenumber-js/max';
import memoizeOne from 'memoize-one';
import './contact-card.css';
import { ReactComponent as PhoneSVG } from '../../assets/images/icons/phone.svg';
import ContactCardApi from './contact-card-api';
const parsePhone = memoizeOne((value = '', defaultCountry = '', safe = true) => {
    const phone = parsePhoneNumberFromString(value, defaultCountry);
    if (!safe && !phone)
        return;
    const safePhone = phone || {};
    const country = safePhone.country || defaultCountry;
    const countryCallingCode = isSupportedCountry(country) ? getCountryCallingCode(country) : '';
    const nationalNumber = safePhone.nationalNumber || value.replace(`+${countryCallingCode.toString()}`, '');
    const formattedNational = (safePhone.formatNational && safePhone.formatNational()) || nationalNumber;
    const prefixedCallingCode = countryCallingCode ? `+${countryCallingCode.toString()}` : '';
    return {
        country,
        countryCallingCode,
        formattedNational,
        nationalNumber,
        get number() {
            return prefixedCallingCode
                ? `${prefixedCallingCode} ${formattedNational}`
                : formattedNational || value;
        },
    };
});
let ContactCard = class ContactCard extends Component {
    static { this.propTypes = {
        title: string,
        name: string,
        emailExpression: expression,
        email: string,
        phone: string,
    }; }
    render() {
        const { title, name, emailExpression, email, phone } = this.props;
        const countryParts = LanguageService.getCurrentLanguage().split('-');
        let country = countryParts[0];
        if (countryParts.length == 2) {
            country = countryParts[1];
        }
        let phoneNumber = phone;
        const parsedPhone = parsePhone(phone, country.toLocaleUpperCase());
        if (parsedPhone) {
            phoneNumber = parsedPhone.number;
        }
        const emailText = `${MessageService.translate(emailExpression)} ${email}`;
        return (React.createElement(Card, { className: "c-contact-card", selectionType: SelectionType.NONE, transparent: true, uuid: generateUUID(), width: 12 },
            React.createElement("div", { className: "c-contact-card__wrapper" },
                React.createElement("span", { className: "c-contact-card__title" }, title),
                React.createElement("div", { className: "c-contact-card__content" },
                    React.createElement("div", { className: "c-contact-card__section c-contact-card__left" },
                        React.createElement("span", { className: "c-contact-card__prop" }, name),
                        React.createElement(Tooltip, { triggers: [TooltipTrigger.ELLIPSIS], value: email },
                            React.createElement("span", { className: "c-contact-card__prop" }, emailText))),
                    React.createElement("div", { className: "c-contact-card__section c-contact-card__right" },
                        React.createElement("div", { className: "c-contact-card__prop c-contact-card__image-prop" },
                            React.createElement(PhoneSVG, null),
                            React.createElement("span", null, phoneNumber)))))));
    }
};
ContactCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ContactCardApi })
], ContactCard);
export default ContactCard;
//# sourceMappingURL=contact-card.js.map